import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { refreshKYCInfo } from '../store/actions/account'
import { generateKYCSession } from '../store/actions/kyc'
import { selectKycProfile } from '../store/selectors/common'
import KycFrame from '../components/popups/kyc/KycFrame'
import { isFinalKycReview } from '../util/kyc.helpers'

const useSumSubVerification = () => {
  const dispatch = useDispatch()
  const { isProcessing, id: accessToken } = useSelector(selectKycProfile)
  const [showSdk, setShowSdk] = useState(false)

  const handleMessage = useCallback(
    (type, payload) => {
      if (
        ['idCheck.onApplicantStatusChanged'].includes(type) &&
        isFinalKycReview(payload)
      ) {
        setShowSdk(false)
        dispatch(refreshKYCInfo())
      }
    },
    [dispatch]
  )

  const handleError = useCallback(
    (error) => {
      // console.error('SumSub error:', error)
      if (error.error === 'Not authorized') {
        dispatch(generateKYCSession())
      } else {
        dispatch(refreshKYCInfo())
      }
    },
    [dispatch]
  )

  const expirationHandler = useCallback(() => {
    dispatch(generateKYCSession())
  }, [dispatch])

  const initKYCProcess = useCallback(() => {
    if (accessToken) {
      setShowSdk(true)
    } else {
      dispatch(generateKYCSession())
      setShowSdk(true)
    }
  }, [accessToken])

  const handleSdkClose = useCallback(() => {
    setShowSdk(false)
    dispatch(refreshKYCInfo())
  }, [])

  return {
    initKYCProcess,
    kycComponent:
      showSdk && accessToken ? (
        <KycFrame
          onCancel={handleSdkClose}
          loading={isProcessing}
          accessToken={accessToken}
          onMessage={handleMessage}
          onError={handleError}
          expirationHandler={expirationHandler}
        />
      ) : null
  }
}

export default useSumSubVerification
